import { FC } from 'react';
import { useRouter } from 'next/router';
import Modal from '@components/common/modal';
import Text from '@components/common/text';
import Button from '@components/common/button';
import {
  useDeletePassReviewPostComments,
  useDeletePassReviewPosts,
  usePassReviewPostComments,
} from '@repository/passReview/usePassReview';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface Props {
  modalState: string | null;
  commentSn: number | null;
  setCommentSn: (sn: number | null) => void;
  onClose: () => void;
}
const Modals: FC<Props> = ({ modalState, commentSn, setCommentSn, onClose }) => {
  const router = useRouter();
  const { query, push } = router;
  const { refetch } = usePassReviewPostComments(Number(query.sn), { enabled: false });
  const { mutateAsync: deleteComment } = useDeletePassReviewPostComments();
  const { mutateAsync: deleteReview } = useDeletePassReviewPosts();

  const handleDelete = async () => {
    if (modalState === 'comment_delete' && commentSn) {
      deleteComment(
        { sn: Number(query.sn), commentSn },
        {
          onSuccess: () => {
            setCommentSn(null);
            refetch();
          },
        },
      );
    }

    if (modalState === 'review_delete') {
      deleteReview(Number(query.sn), {
        onSuccess: () => {
          push(RouteUrl.PASSBOARD);
        },
      });
    }

    onClose();
  };

  const getContents = () => {
    switch (modalState) {
      case 'comment_delete':
        return (
          <>
            <Text fontStyle={FontStyle.H4_B}>댓글을 삭제하시겠어요?</Text>
          </>
        );
      case 'review_delete':
        return (
          <>
            <Text fontStyle={FontStyle.H4_B}>게시글을 삭제하시겠어요?</Text>
            {
              <Text fontStyle={FontStyle.B2_M} color={Colors.C_COOL_GRAY_70} styles={{ marginTop: 16 }}>
                삭제한 게시글은 복구할 수 없습니다.
              </Text>
            }
          </>
        );
      default:
        return '';
    }
  };

  return (
    <Modal visible={!!modalState} dimmed={true}>
      <div className={cx('wrapper')}>
        {getContents()}
        <div className={cx('btnArea')}>
          <Button className={cx('btn')} theme="secondary" onClick={onClose}>
            취소
          </Button>
          <Button className={cx('btn')} theme="primary" onClick={handleDelete}>
            삭제
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default Modals;
